<template>
  <span
    :aria-hidden="decorative"
    :aria-label="title"
    class="material-design-icon"
    role="img"
  >
    <svg
      :fill="fillColor"
      class="icon__svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <path
        d="m2.4078 4.2019-1.607 1.6941 1.8455 1.9608c-0.53984 0.34682-1.0797 0.73365-1.5944 1.1472l2.2598 3.2014c0.66538-0.53356 1.3559-1.0004 2.084-1.4273l2.7996 2.9746c-0.92902 0.45353-1.8204 1.0004-2.6239 1.6541l2.2598 3.2014c0.97924-0.77367 2.084-1.3739 3.2641-1.7741l3.2014 3.3748c-1.5693 0.09337-3.0256 0.66696-4.2057 1.6007l4.5196 6.4028 2.6655-4.8385 0.24757-2.4939m-2.913-16.678c-2.6992 0-5.2728 0.50689-7.6581 1.4273l3.0005 3.2014c1.5191-0.41351 3.0507-0.62694 4.6577-0.62694 4.2434 0 8.1603 1.4806 11.299 4.0017l2.2598-3.2014c-3.7789-3.0146-8.4616-4.8021-13.559-4.8021m0 8.0035c-0.47706 0-0.94158 0-1.4061 0.0667l4.0048 4.2685c1.5316 0.3735 1.4003 0.15631 2.6181 1.1301l3.8223-2.2639c-2.5109-2.0142-5.6495-3.2014-9.0391-3.2014z"
        stroke-width="1.2941"
      />
      <path
        d="m23.65 29.747c3.5201 0 6.3737-2.8536 6.3737-6.3737s-2.8536-6.3737-6.3737-6.3737-6.3737 2.8536-6.3737 6.3737 2.8536 6.3737 6.3737 6.3737m0-14.341c4.4001 0 7.9671 3.567 7.9671 7.9671s-3.567 7.9671-7.9671 7.9671c-4.4058 0-7.9671-3.5852-7.9671-7.9671 0-4.4001 3.567-7.9671 7.9671-7.9671m0.39835 3.9835v4.1827l3.5852 2.1272-0.59753 0.97995-4.1827-2.5096v-4.7802z"
        stroke-width=".79671"
      />
      <title>{{ title }}</title>
    </svg>
  </span>
</template>

<script>
export default {
  name: "NoWifiWaitIcon",
  props: {
    title: {
      type: String,
      default: "No Wifi Wait icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>

<style scoped>
.material-design-icon {
}
.icon__svg {
  height: 1em;
  width: 1em;
}
</style>
